import {
  UPDATE_CHALLENGE_PROGRESS,
  GET_CHALLENGE_DETAILS,
  UPDATE_CHALLENGE_PROGRESS_ERROR,
} from '../types'

const INITIAL_STATE = {
  isRegisteredForActiveFit: false,
  hasPreviousChallenges: false,
  challenges: [],
  activeChallenge: null,
  metrics: [],
  error: null,
}

const userStatsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_CHALLENGE_DETAILS:
      return {
        ...state,
        activeChallenge: payload?.activeChallenge,
        challenges: payload?.challenges,
        isRegisteredForActiveFit: payload?.isRegisteredForActiveFit,
        hasPreviousChallenges: payload?.hasPreviousChallenges,
      }
    case UPDATE_CHALLENGE_PROGRESS:
      return {
        ...state,
        metrics: payload,
        error: null,
      }
    case UPDATE_CHALLENGE_PROGRESS_ERROR:
      return {
        ...state,
        error: payload,
      }
    default:
      return state
  }
}

export default userStatsReducer
